import React, { Component } from 'react';

// Components and Others
import Select from 'components/widgets/Select';
import PropTypes from 'prop-types';
import { Form, Col } from 'react-bootstrap';
import InputNumber from 'components/widgets/InputNumber';

// Material UI
import { withStyles } from '@material-ui/core/styles';
import {
    DialogContent, Dialog, Tooltip, FormControlLabel, Checkbox,
} from '@material-ui/core';

// Components
import DialogAppBar from 'components/widgets/modal/DialogAppBar';
import AmountFinancedContainer from 'components/containers/deals/read/dealTab/AmountFinancedContainer';
import DialogActions from 'components/widgets/modal/DialogActions';

import clsx from 'clsx';
import { MEDIA_QUERY } from 'utils/enum/Core';

const styles = (theme = {}) => ({
    dialogContent: {
        width: '520px',
        padding: theme.spacing(1, 1.8),
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        [`@media (max-width: ${MEDIA_QUERY.W_430}px)`]: {
            width: '100%',
        },
    },
    formStyle: {
        margin: '10px',
    },
    valueDocStamp: {
        marginLeft: theme.spacing(1),
    },
    docStampLabel: {
        whiteSpace: 'nowrap',
    },
    docStampColor: {
        color: '#767676',
    },
    docStampContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
    },
    docStampCheckboxes: {
        marginLeft: '8px',
        alignContent: 'center',
    },
});

// TODO: Work in progress
class AmountFinancedForm extends Component {
    componentDidMount() {
        const { props } = this;

        props.fetchPortfolios();
        props.fetchContracts();
    }

    render() {
        const {
            props: {
                classes,
                toggleModal,
                open,
                onChange,
                onChangeWaiveDocStamp,
                onSave,
                portfolioList,
                contractList,
                docStamp,
                portfolioId,
                contractId,
                waiveDocStamp,
                docStampOverride,
                onChangeDocStampOverride,
                isCalculatingDeal,
            },
        } = this;

        const contractListSelect = contractList.map((item) => ({
            value: item.loanContractTemplateId,
            label: item.name,
        }));

        const portfolioListSelect = portfolioList.map((item) => ({
            value: item.portfolioId,
            label: item.description,
        }));

        const allowOverride = !docStampOverride || (docStampOverride && docStamp > 0);

        return (
            <Dialog
                open={open}
                maxWidth="sm"
                scroll="paper"
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogAppBar title="Amount Financed" onClose={toggleModal} iconSize="sm" titleVariant="h4" />
                <DialogContent className={classes.dialogContent}>
                    <Form className={classes.formStyle}>
                        <Form.Row>
                            <Form.Group className={classes.docStampContainer}>
                                <Form.Label className={clsx(classes.docStampLabel, classes.docStampColor)}>Doc Stamp</Form.Label>
                                <InputNumber
                                    disabled={!docStampOverride}
                                    value={docStamp}
                                    placeholder="0.00"
                                    showCurrency
                                    onChange={(e) => onChange('docStamp', e)}
                                    thousandSeparator
                                    size="sm"
                                />
                            </Form.Group>
                            <Form.Group className={classes.docStampCheckboxes}>
                                <Tooltip title={waiveDocStamp ? 'Cannot use Override while Waive is checked.' : ''}>
                                    <FormControlLabel
                                        control={(
                                            <Checkbox
                                                disabled={waiveDocStamp}
                                                checked={docStampOverride ?? false}
                                                color="primary"
                                                onChange={(e) => onChangeDocStampOverride(e.target.checked)}
                                            />
                                        )}
                                        label="Override"
                                    />
                                </Tooltip>
                            </Form.Group>
                            <Form.Group className={classes.docStampCheckboxes}>
                                <Tooltip title={docStampOverride ? 'Cannot use Waive while Override is checked.' : ''}>
                                    <FormControlLabel
                                        control={(
                                            <Checkbox
                                                disabled={docStampOverride}
                                                checked={waiveDocStamp ?? false}
                                                color="primary"
                                                onChange={(e) => onChangeWaiveDocStamp(e.target.checked)}
                                            />
                                        )}
                                        label="Waive"
                                    />
                                </Tooltip>
                            </Form.Group>
                        </Form.Row>
                        <Form.Group>
                            <Form.Label>Contract Name</Form.Label>
                            <Select
                                name="contractId"
                                placeholder="Select"
                                options={contractListSelect}
                                value={contractId}
                                onChange={onChange}
                                className="basic-multi-select select-bootstrap select-sm"
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Portfolio</Form.Label>
                            <Select
                                name="portfolioId"
                                placeholder="Select"
                                options={portfolioListSelect}
                                value={portfolioId}
                                onChange={onChange}
                                className="basic-multi-select select-bootstrap select-sm"
                            />
                        </Form.Group>
                        <Form.Group as={Col} />
                    </Form>
                </DialogContent>
                <DialogActions
                    titlePrimary={isCalculatingDeal ? 'Calculating' : 'Apply'}
                    onClickSecondary={toggleModal}
                    onClickPrimary={() => {
                        onSave();
                        toggleModal();
                    }}
                    disablePrimaryButton={isCalculatingDeal || !allowOverride}
                    disableSecondaryButton={isCalculatingDeal}
                    primaryButtonTooltip={!allowOverride ? 'Cannot Override a zero amount for DocStamp.' : ''}
                />
            </Dialog>
        );
    }
}

AmountFinancedForm.propTypes = {
    open: PropTypes.bool.isRequired,
    toggleModal: PropTypes.func.isRequired,
    classes: PropTypes.oneOfType([PropTypes.object]).isRequired,
    onChange: PropTypes.func.isRequired,
    onChangeWaiveDocStamp: PropTypes.func.isRequired,
    fetchPortfolios: PropTypes.func.isRequired,
    fetchContracts: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    portfolioId: PropTypes.number.isRequired,
    contractId: PropTypes.number.isRequired,
    portfolioList: PropTypes.array.isRequired,
    contractList: PropTypes.array.isRequired,
    docStamp: PropTypes.number.isRequired,
    waiveDocStamp: PropTypes.bool.isRequired,
    docStampOverride: PropTypes.bool.isRequired,
    onChangeDocStampOverride: PropTypes.func.isRequired,
    isCalculatingDeal: PropTypes.bool.isRequired,
};

export default withStyles(styles)(AmountFinancedContainer(AmountFinancedForm));
